import http from "../http-common";

class InvoiceService {
  // Get all invoices with optional filtering
  getInvoices(params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.visit_id) queryParams.append('visit_id', params.visit_id);
    if (params.client_id) queryParams.append('client_id', params.client_id);
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);
    
    const queryString = queryParams.toString();
    return http.get(`/invoices${queryString ? `?${queryString}` : ''}`);
  }

  // Get invoices by visit
  getInvoicesByVisit(visitId) {
    return http.get(`/invoices?visit_id=${visitId}`);
  }

  // Get invoices by client
  getInvoicesByClient(clientId) {
    return http.get(`/invoices?client_id=${clientId}`);
  }

  // Get single invoice
  getInvoice(id) {
    return http.get(`/invoices/${id}`);
  }

  // Create new invoice
  createInvoice(data) {
    return http.post('/invoices', data);
  }

  // Update invoice
  updateInvoice(id, data) {
    return http.put(`/invoices/${id}`, data);
  }

  // Delete invoice
  deleteInvoice(id) {
    return http.delete(`/invoices/${id}`);
  }

  // Get invoice statistics
  getInvoiceStats() {
    return http.get('/invoices/stats');
  }

  // Print/PDF invoice
  printInvoice(id) {
    return http.get(`/invoices/${id}/print`, { responseType: 'blob' });
  }

  // FEL Operations
  // Certify invoice with FEL
  certifyInvoice(id) {
    return http.post(`/fel/invoices/${id}/certificar`);
  }

  // Cancel certified invoice
  cancelInvoice(id, motivo) {
    return http.post(`/fel/invoices/${id}/anular`, { motivo });
  }

  // Check FEL status
  checkFELStatus(id) {
    return http.get(`/fel/invoices/${id}/estado`);
  }

  // Get FEL XML
  getFELXML(id) {
    return http.get(`/fel/invoices/${id}/xml`);
  }

  // Send invoice via email
  sendInvoiceEmail(id, data) {
    return http.post(`/fel/invoices/${id}/send-email`, data);
  }

  // Send invoice via WhatsApp
  sendInvoiceWhatsApp(id, data) {
    return http.post(`/fel/invoices/${id}/send-whatsapp`, data);
  }
}

export default new InvoiceService();
